import { initContract } from '@ts-rest/core';
import { adminPaymentContract } from './payment.admin.contract';

const c = initContract();

export const paymentContract = c.router(
  {
    admin: adminPaymentContract,
  },
  {
    pathPrefix: '/payment',
    strictStatusCodes: true,
    jsonQuery: true,
  }
);

export * from './models';
export * from './payment.admin.contract';

